export default __webpack_public_path__ + "static/media/green-totla-passenger.31a04f05.svg";